export default function SyncSectionCompareDialogController(
  $q,
  $rootScope,

  loaderService,
  pmDataService,
  ssDialogService,
  alerts,
  $scope,
) {
  const vm = this;
  vm.handleClose = _handleClose;
  vm.handleApprove = _handleApprove;

  _activate();

  /** **************************************************
   * Event Handlers
   */
  function _handleClose() {
    _closeDialog();
  }

  function _handleApprove() {
    loaderService.showViewLoader = true;
    return pmDataService.syncSectionToMaster(vm.section.policyDocumentSectionId).then(() => {
      $rootScope.$broadcast('refreshPMDocumentsAfterSync');
      alerts.success('Section has been synced up with the recommended changes.');
    });
  }

  /** **************************************************
   * Private Functions
   */
  function _activate() {
    $scope.$on('closeSyncDialog', completeSync);
  }

  function completeSync() {
    loaderService.showViewLoader = false;
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.syncSectionCompareDialog);
  }
}

SyncSectionCompareDialogController.$inject = [
  '$q',
  '$rootScope',

  'loaderService',
  'pmDataService',
  'ssDialogService',
  'alerts',
  '$scope',
];
